import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import { Environment } from '../../../shared/environment';

interface IFabricaImpressao{
  idfabrica: string;
	nome: string;
	logo: string;
  itens: IItensImpressao[];
}

interface IItensImpressao{
 	descricao: string;
	quantidade: number;
	un: string;
	preco: number;
	total: number;
  ean: string;
  nome: string;
}

interface IImpressao{
   nome: string;
   cpf: string;
   rg: string;
   cep: string;
   endereco: string;
   bairro: string;
   municipio: string;
   uf: string;
   telefone: string;
   descricao: string;
   emissao: Date;
   numero: number;
   valor: number;
   fabricas: IFabricaImpressao[];
}

 
async function PDFPedidos1(dados: IImpressao){

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  process.env.REACT_APP_URL_IMAGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  // async function getBase64ImageFromUrl1(url: string): Promise<string> {
  //   const response = await fetch(url);
  //   const blob = await response.blob();
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onloadend = () => resolve(reader.result as string);
  //     reader.onerror = () => reject("Erro ao converter imagem para base64");
  //     reader.readAsDataURL(blob);
  //   });
  // }
  const documentDefinition : any = {
 
    content: [
      {
        style: 'tableExample',
        table: {
          margin: [0, 0, 0, 0],
          widths: [148, 580],
          body: [
            [ 
              {
                margin: [0, 20, 0, 0],
                image: imageData,
                width: 148,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],
                table: {
                  widths: [180, 178],
                  body: [
                    [ 
                      {text: 'PRONTA ENTREGA', fontSize: 22, colSpan: 2,  margin: [0, 5, 0, 0], bold: true,  alignment: 'left', border: [false, false, false, false]},
                      {text: '', border: [false, false, false, false]},
                    ],
                    [ 
                      {text: '(71)98179-1818', fontSize: 20, bold: true, margin: [0, 5, 0, 0]},
                      {text: dados.descricao+ '  '+dados.numero, fontSize: 20, bold: true, margin: [0, 5, 0, 0],},
                    ],
                   
                  ]
                }
              }
            ],
          ]
        }
      },
      {
        style: 'tableExample',     
        table: {
          widths: [160, 120, 23, 95, 95],
          body: [
            [ {text: 'RAZAO SOCIAL / NOME\n'+ dados.nome, colSpan: 2, fontSize: 10, alignment: 'left', border: [true, true, false, false] },
              {text: '', border: [false, true, true, false]},
              {text: '', border: [false, true, true, true]},    
              {text: 'CPF / CNPJ\n'+ (dados.cpf.length == 11 ? (  
                dados.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
              ) : (
                dados.cpf.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
              )), fontSize: 10, alignment: 'left', }, 
              {text: 'Data Emissão\n'+ moment(dados.emissao).format('DD/MM/YYYY'), fontSize: 10, alignment: 'left', },
            ],
            [ {text: 'Endereço\n'+dados.endereco, colSpan: 2, fontSize: 10, alignment: 'left', border: [true, true, false, false]  },
              {text: '', border: [false, true, true, false]},
              {text: '', border: [false, true, true, true]},  
              {text: 'CEP\n'+dados.cep, fontSize: 10, alignment: 'left', }, 
              {text: 'Data Saida / Entrada\n '+ moment(dados.emissao).format('DD/MM/YYYY'), fontSize: 10, alignment: 'left', },
            ],
            [ {text: 'Municipio\n'+dados.municipio, fontSize: 10, alignment: 'left', },
              {text: 'Bairro\n'+dados.bairro, fontSize: 10, alignment: 'left',},
              {text: 'UF\n'+ dados.uf, fontSize: 10, alignment: 'left', }, 
              {text: 'Fone / Celular\n '+ dados.telefone, fontSize: 10, alignment: 'left', },
              {text: 'Insc. Estadual Nº\n '+ dados.rg, fontSize: 10, alignment: 'left', },
            ],
          ]
        }
      },
      dados.fabricas.flatMap(e => {
        const { itens } = e;
        const rows = itens.map((row) => [
          { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.quantidade), alignment: 'right', fontSize: 9 },
          { text: row.ean, alignment: 'left', fontSize: 9 },
          { text: row.ean, alignment: 'left', fontSize: 9 },
          { text: row.descricao, alignment: 'left', fontSize: 9 },
          { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.preco), alignment: 'right', fontSize: 9 },
          { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.total), alignment: 'right', fontSize: 9 },
        ]);

        // const imageUrl1 =  process.env.REACT_APP_URL_IMGLOG || ''; 
        // const imageData1 = getBase64ImageFromUrl(imageUrl1);

        return [
          {
            table: {
              widths: [100, 580],
              body: [
                [
                  { text: e.nome, fontSize: 16,  bold: true,  margin: [0, 0, 0, 0], border: [false, false, false, false] },
                  { text: '', fontSize: 16,  bold: true,  margin: [0, 0, 0, 0], border: [false, false, false, false] },
                ],
              ],  
            },
          },
          {
            table: {
              widths: [50, 80, 80, 174, 50, 50],
              body: [
                [
                  { text: 'Quantidade', alignment: 'right', fillColor: '#dddddd', fontSize: 9 },
                  { text: 'Código Barra', alignment: 'center', fillColor: '#dddddd', fontSize: 9 },
                  { text: 'Referência', alignment: 'left', fillColor: '#dddddd', fontSize: 9 },
                  { text: 'Descrição', alignment: 'left', fillColor: '#dddddd', fontSize: 9 },
                  { text: 'Preço Unt.', alignment: 'right', fillColor: '#dddddd', fontSize: 9 },
                  { text: 'Total', alignment: 'right', fillColor: '#dddddd', fontSize: 9 },
                ],
                ...rows,
              ],
            },
          },
        ];
      }),
    ],
};
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default PDFPedidos1;